//#region components/modal/modal_constants.js
var e = {
	default: "",
	critical: "d-modal--critical"
}, t = {
	default: "",
	full: "d-modal--full"
}, n = {
	critical: "d-modal__banner--critical",
	info: "d-modal__banner--info",
	positive: "d-modal__banner--positive",
	warning: "d-modal__banner--warning",
	base: "d-modal__banner--general"
};
//#endregion
export { n as MODAL_BANNER_KINDS, e as MODAL_KIND_MODIFIERS, t as MODAL_SIZE_MODIFIERS };

//# sourceMappingURL=modal-constants.js.map